export default "__VITE_ASSET__B$GB1AsC__"